import { MatDialogConfig } from "@angular/material/dialog";

export function getPosBundleProductConfirmationModalDialogConfig(hasMulipleQuantity?: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = hasMulipleQuantity ? '800px' : '400px';
    dialogConfig.panelClass = ['up-dialog-container', 'messageBox'];
    return dialogConfig;
}